import {
    SET_LAUNCH_DELAY,
    SET_AUTO_LAUNCH_ON_LOGIN,
    SET_AUTO_LAUNCH_ON_STARTUP,
    SET_LAYOUT,
} from '../data/ui/constants'
import { getUiSettings, uiSettingsChanged, setTexts } from '../data'
import { constants as c } from '../imports'
import getLocalizedTexts from '../localization'

function dispatchUiSettingsChanged(store) {
    const uiSettings = getUiSettings(store.getState())
    store.dispatch(uiSettingsChanged(uiSettings))
}

const SettingsMiddleware = store => next => (action) => {
    switch (action.type) {
        case SET_LAUNCH_DELAY:
        case SET_AUTO_LAUNCH_ON_LOGIN:
        case SET_AUTO_LAUNCH_ON_STARTUP:
        case SET_LAYOUT: {
            // todo: Maybe see if the value has actually changed and only dispatch
            // if so.
            const result = next(action)
            dispatchUiSettingsChanged(store)
            return result
        }

        case c.LOCALE_CHANGED: {
            const result = next(action)
            const text = getLocalizedTexts(action.payload)
            store.dispatch(
                setTexts({
                    general: text.general,
                    downloadEverything: text.downloadEverything,
                    runWithLogs: text.runWithLogs,
                    runWithDX9: text.runWithDX9,
                    minimizeToTray: text.minimizeToTray,
                    language: text.language,
                    reset: text.reset,
                    forgetAllAccounts: text.forgetAllAccounts,
                    forgetAllAccountsTooltip: text.forgetAllAccountsTooltip,
                    sharedCacheSettings: text.sharedCacheSettings,
                    resetToDefaults: text.resetToDefaults,
                    manageApiPermissions: text.manageApiPermissions,
                    testServers: text.testServers,
                    launchOptions: text.launchOptions,
                    autoLaunchOnLogin: text.autoLaunchOnLogin,
                    autoLaunchOnLoginTooltip: text.autoLaunchOnLoginTooltip,
                    autoLaunchOnStartup: text.autoLaunchStartup,
                    autoLaunchOnStartupTooltip: text.autoLaunchStartupTooltip,
                    launchDelay: text.launchDelay,
                    seconds: text.seconds,
                    confirmForget: text.confirmForget,
                    settingSavedTitle: text.settingSavedTitle,
                    settingSavedMessage: text.settingSavedMessage,
                    layout: text.layout,
                    layoutDefault: text.layoutDefault,
                    layoutRight: text.layoutRight,
                    layoutLeft: text.layoutLeft,
                }),
            )
            return result
        }

        default:
            return next(action)
    }
}

export default SettingsMiddleware



// WEBPACK FOOTER //
// ./src/features/Settings/middleware/index.js